import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const SaveIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();

    return (
      <IconButton
        aria-label={t('common.save', 'Save')}
        ref={ref}
        {...props}
      >
        <CheckIcon color='inherit' />
      </IconButton>
    );
  },
);

SaveIconButton.displayName = 'SaveIconButton';
export default SaveIconButton;
